// extracted by mini-css-extract-plugin
module.exports = {"menu":"ActionsMenu_menu__1qdJP"};